import { DeepPartial } from "./deepPartial";
import { TagType } from "./tag-type";
import { CategoryTagDTO } from "./tags.dto";

export class ReservationTagCategory {

    constructor(input?: DeepPartial<ReservationTagCategory>) {
        if (input) {
            for (const [key, value] of Object.entries(input)) {
                (this as any)[key] = value;
            }

            if (input.tags != null) {
                this.tags = input.tags.map(t => new ReservationTag(t));
            }
        }
    }

    id: string = "";
    name: string = "";
    color: string = "";
    order?: number = 0;
    tags: ReservationTag[] = [];

    type?: TagType = "CUSTOMER";

    isDietary() {
        return ReservationTagCategory.isCatDietary(this);
    }

    static isCatDietary(cat: ReservationTagCategory) {
        return cat.name == 'Dietary';
    }

    static isCatDtoDietary(cat: CategoryTagDTO) {
        return cat.title == 'Dietary';
    }
}

export class ReservationTag {
    id: string = "";
    title: string = "";
    categoryId: string = "";
    tagOrder?: number = 0;
    deleted?: boolean = false;
    timeperformed?: number = 0;

    constructor(input?: DeepPartial<ReservationTag>) {
        if (input) {
            for (const [key, value] of Object.entries(input)) {
                (this as any)[key] = value;
            }
        }
    }
}